/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StoreImport } from './routes/store'
import { Route as SelectProjectImport } from './routes/select-project'
import { Route as IndexImport } from './routes/index'
import { Route as StoreSettingsImport } from './routes/store/settings'
import { Route as StoreRevisionsImport } from './routes/store/revisions'
import { Route as StoreReviewsImport } from './routes/store/reviews'
import { Route as StoreProductsImport } from './routes/store/products'
import { Route as StoreListsImport } from './routes/store/lists'
import { Route as StoreAnalyticsImport } from './routes/store/analytics'
import { Route as ProductsNewImport } from './routes/products/new'
import { Route as ProductsIdImport } from './routes/products/$id'
import { Route as StoreProductTypesIndexImport } from './routes/store/product-types/index'
import { Route as StorePagesIndexImport } from './routes/store/pages/index'
import { Route as StoreMerchantsIndexImport } from './routes/store/merchants/index'
import { Route as ProductsIdIndexImport } from './routes/products/$id/index'
import { Route as StoreProductTypesIdImport } from './routes/store/product-types/$id'
import { Route as StorePagesIdImport } from './routes/store/pages/$id'
import { Route as StoreMerchantsIdImport } from './routes/store/merchants/$id'
import { Route as ProductsIdSettingsImport } from './routes/products/$id/settings'
import { Route as ProductsIdRevisionsImport } from './routes/products/$id/revisions'
import { Route as ProductsIdReviewsImport } from './routes/products/$id/reviews'
import { Route as ProductsIdPropertiesImport } from './routes/products/$id/properties'
import { Route as ProductsIdEditImport } from './routes/products/$id/edit'
import { Route as ProductsIdAnalyticsImport } from './routes/products/$id/analytics'
import { Route as ProductsIdRevisionsRevisionIdImport } from './routes/products/$id/revisions_.$revisionId'
import { Route as ProductsIdEditRevisionIdImport } from './routes/products/$id/edit_.$revisionId'

// Create/Update Routes

const StoreRoute = StoreImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRoute,
} as any)

const SelectProjectRoute = SelectProjectImport.update({
  id: '/select-project',
  path: '/select-project',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StoreSettingsRoute = StoreSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StoreRoute,
} as any)

const StoreRevisionsRoute = StoreRevisionsImport.update({
  id: '/revisions',
  path: '/revisions',
  getParentRoute: () => StoreRoute,
} as any)

const StoreReviewsRoute = StoreReviewsImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => StoreRoute,
} as any)

const StoreProductsRoute = StoreProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => StoreRoute,
} as any)

const StoreListsRoute = StoreListsImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => StoreRoute,
} as any)

const StoreAnalyticsRoute = StoreAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => StoreRoute,
} as any)

const ProductsNewRoute = ProductsNewImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => rootRoute,
} as any)

const ProductsIdRoute = ProductsIdImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => rootRoute,
} as any)

const StoreProductTypesIndexRoute = StoreProductTypesIndexImport.update({
  id: '/product-types/',
  path: '/product-types/',
  getParentRoute: () => StoreRoute,
} as any)

const StorePagesIndexRoute = StorePagesIndexImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => StoreRoute,
} as any)

const StoreMerchantsIndexRoute = StoreMerchantsIndexImport.update({
  id: '/merchants/',
  path: '/merchants/',
  getParentRoute: () => StoreRoute,
} as any)

const ProductsIdIndexRoute = ProductsIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsIdRoute,
} as any)

const StoreProductTypesIdRoute = StoreProductTypesIdImport.update({
  id: '/product-types/$id',
  path: '/product-types/$id',
  getParentRoute: () => StoreRoute,
} as any)

const StorePagesIdRoute = StorePagesIdImport.update({
  id: '/pages/$id',
  path: '/pages/$id',
  getParentRoute: () => StoreRoute,
} as any)

const StoreMerchantsIdRoute = StoreMerchantsIdImport.update({
  id: '/merchants/$id',
  path: '/merchants/$id',
  getParentRoute: () => StoreRoute,
} as any)

const ProductsIdSettingsRoute = ProductsIdSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProductsIdRoute,
} as any)

const ProductsIdRevisionsRoute = ProductsIdRevisionsImport.update({
  id: '/revisions',
  path: '/revisions',
  getParentRoute: () => ProductsIdRoute,
} as any)

const ProductsIdReviewsRoute = ProductsIdReviewsImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => ProductsIdRoute,
} as any)

const ProductsIdPropertiesRoute = ProductsIdPropertiesImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => ProductsIdRoute,
} as any)

const ProductsIdEditRoute = ProductsIdEditImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ProductsIdRoute,
} as any)

const ProductsIdAnalyticsRoute = ProductsIdAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => ProductsIdRoute,
} as any)

const ProductsIdRevisionsRevisionIdRoute =
  ProductsIdRevisionsRevisionIdImport.update({
    id: '/revisions_/$revisionId',
    path: '/revisions/$revisionId',
    getParentRoute: () => ProductsIdRoute,
  } as any)

const ProductsIdEditRevisionIdRoute = ProductsIdEditRevisionIdImport.update({
  id: '/edit_/$revisionId',
  path: '/edit/$revisionId',
  getParentRoute: () => ProductsIdRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/select-project': {
      id: '/select-project'
      path: '/select-project'
      fullPath: '/select-project'
      preLoaderRoute: typeof SelectProjectImport
      parentRoute: typeof rootRoute
    }
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreImport
      parentRoute: typeof rootRoute
    }
    '/products/$id': {
      id: '/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdImport
      parentRoute: typeof rootRoute
    }
    '/products/new': {
      id: '/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof ProductsNewImport
      parentRoute: typeof rootRoute
    }
    '/store/analytics': {
      id: '/store/analytics'
      path: '/analytics'
      fullPath: '/store/analytics'
      preLoaderRoute: typeof StoreAnalyticsImport
      parentRoute: typeof StoreImport
    }
    '/store/lists': {
      id: '/store/lists'
      path: '/lists'
      fullPath: '/store/lists'
      preLoaderRoute: typeof StoreListsImport
      parentRoute: typeof StoreImport
    }
    '/store/products': {
      id: '/store/products'
      path: '/products'
      fullPath: '/store/products'
      preLoaderRoute: typeof StoreProductsImport
      parentRoute: typeof StoreImport
    }
    '/store/reviews': {
      id: '/store/reviews'
      path: '/reviews'
      fullPath: '/store/reviews'
      preLoaderRoute: typeof StoreReviewsImport
      parentRoute: typeof StoreImport
    }
    '/store/revisions': {
      id: '/store/revisions'
      path: '/revisions'
      fullPath: '/store/revisions'
      preLoaderRoute: typeof StoreRevisionsImport
      parentRoute: typeof StoreImport
    }
    '/store/settings': {
      id: '/store/settings'
      path: '/settings'
      fullPath: '/store/settings'
      preLoaderRoute: typeof StoreSettingsImport
      parentRoute: typeof StoreImport
    }
    '/products/$id/analytics': {
      id: '/products/$id/analytics'
      path: '/analytics'
      fullPath: '/products/$id/analytics'
      preLoaderRoute: typeof ProductsIdAnalyticsImport
      parentRoute: typeof ProductsIdImport
    }
    '/products/$id/edit': {
      id: '/products/$id/edit'
      path: '/edit'
      fullPath: '/products/$id/edit'
      preLoaderRoute: typeof ProductsIdEditImport
      parentRoute: typeof ProductsIdImport
    }
    '/products/$id/properties': {
      id: '/products/$id/properties'
      path: '/properties'
      fullPath: '/products/$id/properties'
      preLoaderRoute: typeof ProductsIdPropertiesImport
      parentRoute: typeof ProductsIdImport
    }
    '/products/$id/reviews': {
      id: '/products/$id/reviews'
      path: '/reviews'
      fullPath: '/products/$id/reviews'
      preLoaderRoute: typeof ProductsIdReviewsImport
      parentRoute: typeof ProductsIdImport
    }
    '/products/$id/revisions': {
      id: '/products/$id/revisions'
      path: '/revisions'
      fullPath: '/products/$id/revisions'
      preLoaderRoute: typeof ProductsIdRevisionsImport
      parentRoute: typeof ProductsIdImport
    }
    '/products/$id/settings': {
      id: '/products/$id/settings'
      path: '/settings'
      fullPath: '/products/$id/settings'
      preLoaderRoute: typeof ProductsIdSettingsImport
      parentRoute: typeof ProductsIdImport
    }
    '/store/merchants/$id': {
      id: '/store/merchants/$id'
      path: '/merchants/$id'
      fullPath: '/store/merchants/$id'
      preLoaderRoute: typeof StoreMerchantsIdImport
      parentRoute: typeof StoreImport
    }
    '/store/pages/$id': {
      id: '/store/pages/$id'
      path: '/pages/$id'
      fullPath: '/store/pages/$id'
      preLoaderRoute: typeof StorePagesIdImport
      parentRoute: typeof StoreImport
    }
    '/store/product-types/$id': {
      id: '/store/product-types/$id'
      path: '/product-types/$id'
      fullPath: '/store/product-types/$id'
      preLoaderRoute: typeof StoreProductTypesIdImport
      parentRoute: typeof StoreImport
    }
    '/products/$id/': {
      id: '/products/$id/'
      path: '/'
      fullPath: '/products/$id/'
      preLoaderRoute: typeof ProductsIdIndexImport
      parentRoute: typeof ProductsIdImport
    }
    '/store/merchants/': {
      id: '/store/merchants/'
      path: '/merchants'
      fullPath: '/store/merchants'
      preLoaderRoute: typeof StoreMerchantsIndexImport
      parentRoute: typeof StoreImport
    }
    '/store/pages/': {
      id: '/store/pages/'
      path: '/pages'
      fullPath: '/store/pages'
      preLoaderRoute: typeof StorePagesIndexImport
      parentRoute: typeof StoreImport
    }
    '/store/product-types/': {
      id: '/store/product-types/'
      path: '/product-types'
      fullPath: '/store/product-types'
      preLoaderRoute: typeof StoreProductTypesIndexImport
      parentRoute: typeof StoreImport
    }
    '/products/$id/edit_/$revisionId': {
      id: '/products/$id/edit_/$revisionId'
      path: '/edit/$revisionId'
      fullPath: '/products/$id/edit/$revisionId'
      preLoaderRoute: typeof ProductsIdEditRevisionIdImport
      parentRoute: typeof ProductsIdImport
    }
    '/products/$id/revisions_/$revisionId': {
      id: '/products/$id/revisions_/$revisionId'
      path: '/revisions/$revisionId'
      fullPath: '/products/$id/revisions/$revisionId'
      preLoaderRoute: typeof ProductsIdRevisionsRevisionIdImport
      parentRoute: typeof ProductsIdImport
    }
  }
}

// Create and export the route tree

interface StoreRouteChildren {
  StoreAnalyticsRoute: typeof StoreAnalyticsRoute
  StoreListsRoute: typeof StoreListsRoute
  StoreProductsRoute: typeof StoreProductsRoute
  StoreReviewsRoute: typeof StoreReviewsRoute
  StoreRevisionsRoute: typeof StoreRevisionsRoute
  StoreSettingsRoute: typeof StoreSettingsRoute
  StoreMerchantsIdRoute: typeof StoreMerchantsIdRoute
  StorePagesIdRoute: typeof StorePagesIdRoute
  StoreProductTypesIdRoute: typeof StoreProductTypesIdRoute
  StoreMerchantsIndexRoute: typeof StoreMerchantsIndexRoute
  StorePagesIndexRoute: typeof StorePagesIndexRoute
  StoreProductTypesIndexRoute: typeof StoreProductTypesIndexRoute
}

const StoreRouteChildren: StoreRouteChildren = {
  StoreAnalyticsRoute: StoreAnalyticsRoute,
  StoreListsRoute: StoreListsRoute,
  StoreProductsRoute: StoreProductsRoute,
  StoreReviewsRoute: StoreReviewsRoute,
  StoreRevisionsRoute: StoreRevisionsRoute,
  StoreSettingsRoute: StoreSettingsRoute,
  StoreMerchantsIdRoute: StoreMerchantsIdRoute,
  StorePagesIdRoute: StorePagesIdRoute,
  StoreProductTypesIdRoute: StoreProductTypesIdRoute,
  StoreMerchantsIndexRoute: StoreMerchantsIndexRoute,
  StorePagesIndexRoute: StorePagesIndexRoute,
  StoreProductTypesIndexRoute: StoreProductTypesIndexRoute,
}

const StoreRouteWithChildren = StoreRoute._addFileChildren(StoreRouteChildren)

interface ProductsIdRouteChildren {
  ProductsIdAnalyticsRoute: typeof ProductsIdAnalyticsRoute
  ProductsIdEditRoute: typeof ProductsIdEditRoute
  ProductsIdPropertiesRoute: typeof ProductsIdPropertiesRoute
  ProductsIdReviewsRoute: typeof ProductsIdReviewsRoute
  ProductsIdRevisionsRoute: typeof ProductsIdRevisionsRoute
  ProductsIdSettingsRoute: typeof ProductsIdSettingsRoute
  ProductsIdIndexRoute: typeof ProductsIdIndexRoute
  ProductsIdEditRevisionIdRoute: typeof ProductsIdEditRevisionIdRoute
  ProductsIdRevisionsRevisionIdRoute: typeof ProductsIdRevisionsRevisionIdRoute
}

const ProductsIdRouteChildren: ProductsIdRouteChildren = {
  ProductsIdAnalyticsRoute: ProductsIdAnalyticsRoute,
  ProductsIdEditRoute: ProductsIdEditRoute,
  ProductsIdPropertiesRoute: ProductsIdPropertiesRoute,
  ProductsIdReviewsRoute: ProductsIdReviewsRoute,
  ProductsIdRevisionsRoute: ProductsIdRevisionsRoute,
  ProductsIdSettingsRoute: ProductsIdSettingsRoute,
  ProductsIdIndexRoute: ProductsIdIndexRoute,
  ProductsIdEditRevisionIdRoute: ProductsIdEditRevisionIdRoute,
  ProductsIdRevisionsRevisionIdRoute: ProductsIdRevisionsRevisionIdRoute,
}

const ProductsIdRouteWithChildren = ProductsIdRoute._addFileChildren(
  ProductsIdRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/select-project': typeof SelectProjectRoute
  '/store': typeof StoreRouteWithChildren
  '/products/$id': typeof ProductsIdRouteWithChildren
  '/products/new': typeof ProductsNewRoute
  '/store/analytics': typeof StoreAnalyticsRoute
  '/store/lists': typeof StoreListsRoute
  '/store/products': typeof StoreProductsRoute
  '/store/reviews': typeof StoreReviewsRoute
  '/store/revisions': typeof StoreRevisionsRoute
  '/store/settings': typeof StoreSettingsRoute
  '/products/$id/analytics': typeof ProductsIdAnalyticsRoute
  '/products/$id/edit': typeof ProductsIdEditRoute
  '/products/$id/properties': typeof ProductsIdPropertiesRoute
  '/products/$id/reviews': typeof ProductsIdReviewsRoute
  '/products/$id/revisions': typeof ProductsIdRevisionsRoute
  '/products/$id/settings': typeof ProductsIdSettingsRoute
  '/store/merchants/$id': typeof StoreMerchantsIdRoute
  '/store/pages/$id': typeof StorePagesIdRoute
  '/store/product-types/$id': typeof StoreProductTypesIdRoute
  '/products/$id/': typeof ProductsIdIndexRoute
  '/store/merchants': typeof StoreMerchantsIndexRoute
  '/store/pages': typeof StorePagesIndexRoute
  '/store/product-types': typeof StoreProductTypesIndexRoute
  '/products/$id/edit/$revisionId': typeof ProductsIdEditRevisionIdRoute
  '/products/$id/revisions/$revisionId': typeof ProductsIdRevisionsRevisionIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/select-project': typeof SelectProjectRoute
  '/store': typeof StoreRouteWithChildren
  '/products/new': typeof ProductsNewRoute
  '/store/analytics': typeof StoreAnalyticsRoute
  '/store/lists': typeof StoreListsRoute
  '/store/products': typeof StoreProductsRoute
  '/store/reviews': typeof StoreReviewsRoute
  '/store/revisions': typeof StoreRevisionsRoute
  '/store/settings': typeof StoreSettingsRoute
  '/products/$id/analytics': typeof ProductsIdAnalyticsRoute
  '/products/$id/edit': typeof ProductsIdEditRoute
  '/products/$id/properties': typeof ProductsIdPropertiesRoute
  '/products/$id/reviews': typeof ProductsIdReviewsRoute
  '/products/$id/revisions': typeof ProductsIdRevisionsRoute
  '/products/$id/settings': typeof ProductsIdSettingsRoute
  '/store/merchants/$id': typeof StoreMerchantsIdRoute
  '/store/pages/$id': typeof StorePagesIdRoute
  '/store/product-types/$id': typeof StoreProductTypesIdRoute
  '/products/$id': typeof ProductsIdIndexRoute
  '/store/merchants': typeof StoreMerchantsIndexRoute
  '/store/pages': typeof StorePagesIndexRoute
  '/store/product-types': typeof StoreProductTypesIndexRoute
  '/products/$id/edit/$revisionId': typeof ProductsIdEditRevisionIdRoute
  '/products/$id/revisions/$revisionId': typeof ProductsIdRevisionsRevisionIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/select-project': typeof SelectProjectRoute
  '/store': typeof StoreRouteWithChildren
  '/products/$id': typeof ProductsIdRouteWithChildren
  '/products/new': typeof ProductsNewRoute
  '/store/analytics': typeof StoreAnalyticsRoute
  '/store/lists': typeof StoreListsRoute
  '/store/products': typeof StoreProductsRoute
  '/store/reviews': typeof StoreReviewsRoute
  '/store/revisions': typeof StoreRevisionsRoute
  '/store/settings': typeof StoreSettingsRoute
  '/products/$id/analytics': typeof ProductsIdAnalyticsRoute
  '/products/$id/edit': typeof ProductsIdEditRoute
  '/products/$id/properties': typeof ProductsIdPropertiesRoute
  '/products/$id/reviews': typeof ProductsIdReviewsRoute
  '/products/$id/revisions': typeof ProductsIdRevisionsRoute
  '/products/$id/settings': typeof ProductsIdSettingsRoute
  '/store/merchants/$id': typeof StoreMerchantsIdRoute
  '/store/pages/$id': typeof StorePagesIdRoute
  '/store/product-types/$id': typeof StoreProductTypesIdRoute
  '/products/$id/': typeof ProductsIdIndexRoute
  '/store/merchants/': typeof StoreMerchantsIndexRoute
  '/store/pages/': typeof StorePagesIndexRoute
  '/store/product-types/': typeof StoreProductTypesIndexRoute
  '/products/$id/edit_/$revisionId': typeof ProductsIdEditRevisionIdRoute
  '/products/$id/revisions_/$revisionId': typeof ProductsIdRevisionsRevisionIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/select-project'
    | '/store'
    | '/products/$id'
    | '/products/new'
    | '/store/analytics'
    | '/store/lists'
    | '/store/products'
    | '/store/reviews'
    | '/store/revisions'
    | '/store/settings'
    | '/products/$id/analytics'
    | '/products/$id/edit'
    | '/products/$id/properties'
    | '/products/$id/reviews'
    | '/products/$id/revisions'
    | '/products/$id/settings'
    | '/store/merchants/$id'
    | '/store/pages/$id'
    | '/store/product-types/$id'
    | '/products/$id/'
    | '/store/merchants'
    | '/store/pages'
    | '/store/product-types'
    | '/products/$id/edit/$revisionId'
    | '/products/$id/revisions/$revisionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/select-project'
    | '/store'
    | '/products/new'
    | '/store/analytics'
    | '/store/lists'
    | '/store/products'
    | '/store/reviews'
    | '/store/revisions'
    | '/store/settings'
    | '/products/$id/analytics'
    | '/products/$id/edit'
    | '/products/$id/properties'
    | '/products/$id/reviews'
    | '/products/$id/revisions'
    | '/products/$id/settings'
    | '/store/merchants/$id'
    | '/store/pages/$id'
    | '/store/product-types/$id'
    | '/products/$id'
    | '/store/merchants'
    | '/store/pages'
    | '/store/product-types'
    | '/products/$id/edit/$revisionId'
    | '/products/$id/revisions/$revisionId'
  id:
    | '__root__'
    | '/'
    | '/select-project'
    | '/store'
    | '/products/$id'
    | '/products/new'
    | '/store/analytics'
    | '/store/lists'
    | '/store/products'
    | '/store/reviews'
    | '/store/revisions'
    | '/store/settings'
    | '/products/$id/analytics'
    | '/products/$id/edit'
    | '/products/$id/properties'
    | '/products/$id/reviews'
    | '/products/$id/revisions'
    | '/products/$id/settings'
    | '/store/merchants/$id'
    | '/store/pages/$id'
    | '/store/product-types/$id'
    | '/products/$id/'
    | '/store/merchants/'
    | '/store/pages/'
    | '/store/product-types/'
    | '/products/$id/edit_/$revisionId'
    | '/products/$id/revisions_/$revisionId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SelectProjectRoute: typeof SelectProjectRoute
  StoreRoute: typeof StoreRouteWithChildren
  ProductsIdRoute: typeof ProductsIdRouteWithChildren
  ProductsNewRoute: typeof ProductsNewRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SelectProjectRoute: SelectProjectRoute,
  StoreRoute: StoreRouteWithChildren,
  ProductsIdRoute: ProductsIdRouteWithChildren,
  ProductsNewRoute: ProductsNewRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/select-project",
        "/store",
        "/products/$id",
        "/products/new"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/select-project": {
      "filePath": "select-project.tsx"
    },
    "/store": {
      "filePath": "store.tsx",
      "children": [
        "/store/analytics",
        "/store/lists",
        "/store/products",
        "/store/reviews",
        "/store/revisions",
        "/store/settings",
        "/store/merchants/$id",
        "/store/pages/$id",
        "/store/product-types/$id",
        "/store/merchants/",
        "/store/pages/",
        "/store/product-types/"
      ]
    },
    "/products/$id": {
      "filePath": "products/$id.tsx",
      "children": [
        "/products/$id/analytics",
        "/products/$id/edit",
        "/products/$id/properties",
        "/products/$id/reviews",
        "/products/$id/revisions",
        "/products/$id/settings",
        "/products/$id/",
        "/products/$id/edit_/$revisionId",
        "/products/$id/revisions_/$revisionId"
      ]
    },
    "/products/new": {
      "filePath": "products/new.tsx"
    },
    "/store/analytics": {
      "filePath": "store/analytics.tsx",
      "parent": "/store"
    },
    "/store/lists": {
      "filePath": "store/lists.tsx",
      "parent": "/store"
    },
    "/store/products": {
      "filePath": "store/products.tsx",
      "parent": "/store"
    },
    "/store/reviews": {
      "filePath": "store/reviews.tsx",
      "parent": "/store"
    },
    "/store/revisions": {
      "filePath": "store/revisions.tsx",
      "parent": "/store"
    },
    "/store/settings": {
      "filePath": "store/settings.tsx",
      "parent": "/store"
    },
    "/products/$id/analytics": {
      "filePath": "products/$id/analytics.ts",
      "parent": "/products/$id"
    },
    "/products/$id/edit": {
      "filePath": "products/$id/edit.ts",
      "parent": "/products/$id"
    },
    "/products/$id/properties": {
      "filePath": "products/$id/properties.ts",
      "parent": "/products/$id"
    },
    "/products/$id/reviews": {
      "filePath": "products/$id/reviews.ts",
      "parent": "/products/$id"
    },
    "/products/$id/revisions": {
      "filePath": "products/$id/revisions.ts",
      "parent": "/products/$id"
    },
    "/products/$id/settings": {
      "filePath": "products/$id/settings.ts",
      "parent": "/products/$id"
    },
    "/store/merchants/$id": {
      "filePath": "store/merchants/$id.tsx",
      "parent": "/store"
    },
    "/store/pages/$id": {
      "filePath": "store/pages/$id.tsx",
      "parent": "/store"
    },
    "/store/product-types/$id": {
      "filePath": "store/product-types/$id.tsx",
      "parent": "/store"
    },
    "/products/$id/": {
      "filePath": "products/$id/index.ts",
      "parent": "/products/$id"
    },
    "/store/merchants/": {
      "filePath": "store/merchants/index.tsx",
      "parent": "/store"
    },
    "/store/pages/": {
      "filePath": "store/pages/index.tsx",
      "parent": "/store"
    },
    "/store/product-types/": {
      "filePath": "store/product-types/index.tsx",
      "parent": "/store"
    },
    "/products/$id/edit_/$revisionId": {
      "filePath": "products/$id/edit_.$revisionId.ts",
      "parent": "/products/$id"
    },
    "/products/$id/revisions_/$revisionId": {
      "filePath": "products/$id/revisions_.$revisionId.tsx",
      "parent": "/products/$id"
    }
  }
}
ROUTE_MANIFEST_END */
